<template>
	<header class="header" :class="{fixed: scrollPosition > 5}">
		<div class="side-menu-overlay" @click="toggleMenu()" :class="{sideOverlay:show}"></div>
		<div class="container wd-container">
			<div class="header-wrap d-flex flex-wrap align-items-center">
				<div class="head-left">
					<div class="logo">
						<router-link to="/">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.2 39.3" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="st0" d="M24.9 11.9c-1.4 0-2.6 1.2-2.6 2.6v18.2h-5.2V14.5c0-.2 0-.4-.1-.5-.2-.9-.8-1.6-1.7-1.9h-.1c-.1 0-.2 0-.2-.1-.2 0-.3-.1-.5-.1s-.4 0-.5.1c-.1 0-.2 0-.2.1-.3.1-.5.2-.8.4l-.1.1c-.5.4-.8 1-.9 1.7V25c0 .9-.2 1.8-.4 2.6-.8 2.2-2.5 4-4.8 4.8-.8.3-1.7.4-2.6.4-.7 0-1.4-.1-2.1-.3 3.2 3.2 7.6 5.1 12.5 5.1 5.1 0 9.8-2.2 13-5.6V14.6c-.1-1.6-1.2-2.7-2.7-2.7z"/><path class="st0" d="M4.1 27.5c1.4 0 2.6-1.2 2.6-2.6V14.5c0-.9.2-1.8.4-2.6.8-2.2 2.5-4 4.8-4.8.8-.3 1.7-.4 2.6-.4.9 0 1.8.2 2.6.4 1 .3 1.9.9 2.6 1.5.8-.7 1.6-1.2 2.6-1.5.8-.3 1.7-.4 2.6-.4.7 0 1.4.1 2.1.3-3.2-3.2-7.6-5.1-12.5-5.1-5.1 0-9.8 2.2-13 5.6V24.9c0 1.4 1.1 2.6 2.6 2.6z"/><g><path class="st0" d="M47.2 24c.3 0 .6.3.6.6v2.8c0 .3-.3.6-.6.6H32.5c-.3 0-.6-.3-.6-.6V5.7c0-.3.3-.6.6-.6h2.8c.3 0 .6.3.6.6v17.8c0 .3.3.6.6.6h10.7zM60.5 11.7c0-.3.3-.6.6-.6h2.5c.3 0 .6.3.6.6v8c0 .3 0 .8-.1 1.1 0 0-.1 1.3-.5 2.2-.4.9-.9 1.6-1.5 2.3-.6.7-1.4 1.2-2.3 1.6-.9.4-1.8.6-2.8.6-1 0-1.9-.2-2.8-.6-.9-.4-1.6-.9-2.3-1.6-.7-.7-1.2-1.4-1.6-2.3-.4-.9-.6-1.8-.6-2.8v-8.6c0-.3.3-.6.6-.6h2.5c.3 0 .6.3.6.6v8c0 .3 0 .8.1 1.1 0 0 0 .4.2.8s.4.8.8 1.1c.3.3.7.6 1.1.7.4.2.9.3 1.4.3.5 0 .9-.1 1.3-.3.4-.2.8-.4 1.1-.7.3-.3.6-.7.8-1.1.2-.4.3-.9.3-1.3v-8.5zM66.4 11.6c-.1-.3 0-.5.3-.5h3c.3 0 .7.2.8.5l4.2 9.7c.1.3.3.3.5 0l4.2-9.7c.1-.3.5-.5.8-.5h3c.3 0 .5.2.3.5l-6.7 15.3c-.1.3-.5.5-.8.5h-2.2c-.3 0-.7-.2-.8-.5l-6.6-15.3zM85.8 6.5c0-.5.2-1 .5-1.4.4-.4.8-.5 1.3-.5s1 .2 1.4.5c.4.4.5.8.5 1.4 0 .5-.2.9-.5 1.3-.4.4-.8.5-1.4.5-.5 0-.9-.2-1.3-.5-.3-.3-.5-.7-.5-1.3zm-.1 5.2c0-.3.3-.6.6-.6H89c.3 0 .6.3.6.6v15.2c0 .3-.3.6-.6.6h-2.7c-.3 0-.6-.3-.6-.6V11.7zM91.6 12.4c0-.3.3-.6.6-.6h2.5c.3 0 .6.2.6.4s.2.3.4 0c0 0 .6-.6 1.1-.8.5-.2 1.2-.4 1.9-.4 1.1 0 2 .2 2.9.6.9.4 1.6 1 2.3 1.7.7-.7 1.5-1.3 2.4-1.7.9-.4 1.9-.6 3-.6 1 0 1.9.2 2.8.6.9.4 1.6.9 2.2 1.5.6.6 1.1 1.4 1.5 2.3.4.9.6 1.8.6 2.8v8.6c0 .3-.3.6-.6.6h-2.5c-.3 0-.6-.3-.6-.6v-8.1c0-.3 0-.8-.1-1.1 0 0 0-.3-.2-.7-.2-.4-.4-.8-.7-1.1-.3-.3-.7-.6-1.1-.7-.4-.2-.9-.3-1.3-.3-.5 0-.9.1-1.3.3-.4.2-.8.4-1.1.7-.3.3-.6.7-.7 1.1-.2.4-.3.9-.3 1.3v8.6c0 .3-.3.6-.6.6h-2.5c-.3 0-.6-.3-.6-.6v-8.1c0-.3 0-.8-.1-1.1 0 0 0-.4-.2-.8s-.4-.8-.7-1.1c-.3-.3-.7-.6-1.1-.7-.4-.2-.9-.3-1.3-.3-.5 0-.9.1-1.3.3-.4.2-.8.4-1.1.8-.3.3-.6.7-.7 1.1-.2.4-.3.8-.3 1.3v8.6c0 .3-.3.6-.6.6h-2.5c-.3 0-.6-.3-.6-.6V12.4zM118.2 19.2c0-1.1.2-2.2.6-3.2.4-1 1-1.8 1.8-2.6.7-.7 1.6-1.3 2.6-1.7 1-.4 2.1-.6 3.2-.6s2.2.2 3.2.6c1 .4 1.8 1 2.6 1.7.7.7 1.3 1.6 1.7 2.6.4 1 .6 2.1.6 3.2v7c0 .3-.3.6-.6.6h-2.3c-.3 0-.6-.2-.6-.4s-.2-.3-.5-.2c0 0-2.4 1.2-4.2 1.2-1.2 0-2.4-.2-3.4-.6-1-.4-1.9-1-2.6-1.7-.7-.7-1.3-1.6-1.6-2.6-.3-1.1-.5-2.1-.5-3.3zm3.5 0c0 .6.1 1.2.4 1.8.3.6.6 1.1 1 1.5.4.4.9.8 1.5 1 .6.3 1.2.4 1.8.4.6 0 1.2-.1 1.8-.3.6-.2 1.1-.6 1.5-1 .4-.4.8-.9 1-1.5.3-.6.4-1.2.4-1.9 0-.6-.1-1.2-.4-1.8-.3-.6-.6-1.1-1-1.5-.4-.4-.9-.8-1.5-1-.6-.2-1.2-.4-1.8-.4-.6 0-1.2.1-1.8.4-.6.3-1.1.6-1.5 1-.4.4-.8.9-1 1.5-.3.6-.4 1.2-.4 1.8zM140.1 19.2c0 .6.1 1.3.4 1.8.3.6.6 1.1 1 1.5.4.4.9.8 1.5 1 .6.3 1.2.4 1.8.4.8 0 1.5-.1 2.1-.4.6-.3 1.2-.7 1.6-1.3h3.4c.3 0 .5.2.3.5 0 0-.6 1.2-1.1 1.8-.6.7-1.2 1.2-1.8 1.6-.7.4-1.4.7-2.1.9-.7.2-1.5.3-2.3.3-1.1 0-2.2-.2-3.2-.6-1-.4-1.9-1-2.6-1.7-.7-.7-1.3-1.6-1.7-2.6-.4-1-.6-2.1-.6-3.2s.2-2.2.6-3.2c.4-1 1-1.9 1.7-2.6.7-.7 1.6-1.3 2.6-1.7 1-.4 2.1-.6 3.2-.6.7 0 1.5.1 2.2.3.8.2 1.5.5 2.1.9.7.4 1.3 1 1.9 1.6.6.7 1 1.4 1.4 2.4H149c-.3 0-.7-.2-1-.4 0 0-.6-.6-1.2-.9-.6-.3-1.3-.4-2.1-.4-.6 0-1.3.1-1.8.4-.6.3-1.1.6-1.5 1-.4.4-.8.9-1 1.5-.2.5-.3 1.1-.3 1.7z"/><g><path class="st0" d="M33.5 32.6v.2l1.5 1.8v.1h-.7c-.1 0-.2 0-.2-.1L32.8 33c0-.1-.1 0-.1 0v1.5c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v1.5c0 .1 0 .1.1 0l1.3-1.5c0-.1.1-.1.2-.1h.7c.1 0 .1 0 0 .1l-1.5 1.7zM39 31.4c-.1 0-.1.1-.1.1v.7c0 .1.1.1.1.1h1.1c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1H39c-.1 0-.1.1-.1.1v.8c0 .1.1.1.1.1h1.3c.1 0 .1.1.1.1v.4c0 .1-.1.1-.1.1h-2c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1H39zM44.4 31.4c-.1 0-.1.1-.1.1v.7c0 .1.1.1.1.1h1.1c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.1c-.1 0-.1.1-.1.1v.8c0 .1.1.1.1.1h1.3c.1 0 .1.1.1.1v.4c0 .1-.1.1-.1.1h-2c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.3zM49.8 33.2c-.1 0-.1.1-.1.1v1.2c0 .1-.1.1-.1.1H49c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1H50.4s.7.1.9.3c.2.2.3.5.3.9s-.1.7-.4.9c-.2.2-.9.3-.9.3h-.5zm1.1-1.2c0-.2-.1-.3-.2-.4-.1-.1-.4-.1-.4-.1h-.6c-.1 0-.1.1-.1.1v.9c0 .1.1.1.1.1h.6c.1-.1.6-.2.6-.6zM61.4 30.8c.1 0 .1.1.1.1l-1.2 2.3c0 .1-.1.2-.1.3v1.1c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-1.1c0-.1 0-.2-.1-.3l-1.2-2.3c0-.1 0-.1.1-.1h.6c.1 0 .2.1.2.1l.7 1.5c0 .1.1.1.1 0l.7-1.5c0-.1.1-.1.2-.1h.6zM67.3 31c.3.2.5.4.7.7.2.3.3.6.3 1s-.1.7-.3 1c-.2.3-.4.5-.7.7-.3.2-.6.3-1 .3s-.7-.1-1-.3c-.3-.2-.5-.4-.7-.7-.2-.3-.3-.6-.3-1s.1-.7.3-1c.2-.3.4-.5.7-.7.3-.2.6-.3 1-.3s.7.1 1 .3zm-1.6.6c-.2.1-.3.3-.4.4-.1.2-.1.4-.1.7s0 .5.1.7c.1.2.2.3.4.4.2.1.4.2.6.2s.4-.1.6-.2c.2-.1.3-.3.4-.4.1-.2.1-.4.1-.7s0-.5-.1-.7c-.1-.2-.2-.3-.4-.4-.2-.1-.4-.2-.6-.2s-.4.1-.6.2zM72 30.8c.1 0 .1.1.1.1v2.3s.1.4.2.6c.1.2.3.2.6.2.2 0 .4-.1.6-.2.1-.2.2-.6.2-.6v-2.3c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v2.3s-.1.5-.2.8c-.1.2-.3.4-.6.6-.2.1-.5.2-.8.2-.5 0-.8-.1-1.1-.4-.3-.3-.4-1.1-.4-1.1V31c0-.1.1-.1.1-.1h.6zM79.8 34.6c-.1 0-.2-.1-.2-.1l-.8-1.3c0-.1-.1-.1-.2-.1h-.1c-.1 0-.1.1-.1.1v1.2c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h1.5s.7.1.9.3c.2.2.4.5.4.9 0 .3-.1.5-.2.7-.2.2-.6.3-.6.3-.1 0-.1.1-.1.2l.8 1.3c0 .1 0 .1-.1.1h-.6zm-1.3-2.1c0 .1.1.1.1.1h.7s.5-.2.5-.6c0-.2-.1-.3-.2-.4-.1-.1-.4-.1-.4-.1h-.7c-.1 0-.1.1-.1.1v.9zM90.5 33.7c-.2.3-.4.5-.7.7-.3.2-1 .2-1 .2H87.4c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1H88.8s.7.1 1 .2c.3.2.5.4.7.7.2.3.2.6.2 1s0 .7-.2 1zm-.9-.1c.2-.2.3-.5.3-.9s-.1-.7-.3-.9c-.2-.2-.8-.3-.8-.3h-.6c-.1 0-.1.1-.1.1v2.2c0 .1.1.1.1.1h.6s.6-.1.8-.3zM96 34.6c-.1 0-.2-.1-.2-.1l-.8-1.3c0-.1-.1-.1-.2-.1h-.1c-.1 0-.1.1-.1.1v1.2c0 .1-.1.1-.1.1H94c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h1.5s.7.1.9.3c.2.2.4.5.4.9 0 .3-.1.5-.2.7-.2.2-.6.3-.6.3-.1 0-.1.1-.1.2l.8 1.3c0 .1 0 .1-.1.1H96zm-1.4-2.1c0 .1.1.1.1.1h.7s.5-.2.5-.6c0-.2-.1-.3-.2-.4-.1-.1-.4-.1-.4-.1h-.7c-.1 0-.1.1-.1.1v.9zM100.7 31.4c-.1 0-.1.1-.1.1v.7c0 .1.1.1.1.1h1.1c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.1c-.1 0-.1.1-.1.1v.8c0 .1.1.1.1.1h1.3c.1 0 .1.1.1.1v.4c0 .1-.1.1-.1.1h-2c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.3zM107.6 34c0-.1-.1-.1-.2-.1h-1.3c-.1 0-.2.1-.2.1l-.2.5c0 .1-.1.1-.2.1h-.5c-.1 0-.1-.1-.1-.1l1.3-3.6c0-.1.1-.1.2-.1h.6c.1 0 .2.1.2.1l1.3 3.6c0 .1 0 .1-.1.1h-.6c-.1 0-.2-.1-.2-.1V34zm-.4-.7c.1 0 .1-.1.1-.1l-.5-1.4c0-.1-.1-.1-.1 0l-.5 1.4c0 .1 0 .1.1.1h.9zM115.6 30.8c.1 0 .1.1.1.1v3.6c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-2.4c0-.1 0-.1 0 0l-.9 2.4c0 .1-.1.1-.2.1h-.4c-.1 0-.2-.1-.2-.1l-.9-2.4c0-.1 0-.1 0 0v2.4c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h.7c.1 0 .2.1.2.1l1.1 2.6c0 .1.1.1.1 0l1-2.6c0-.1.1-.1.2-.1h.5zM121.5 34.1c-.1.2-.2.3-.4.4-.2.1-.4.2-.7.2-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.5-.4-.1-.2-.2-.5-.2-.5 0-.1 0-.1.1-.1h.6c.1 0 .2.1.2.1s0 .2.2.3c.1.1.3.2.4.2.2 0 .3 0 .4-.1.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.2-.1 0-.3-.1-.4-.2-.2-.1-.4-.2-.6-.2-.2-.1-.3-.2-.4-.3-.1-.2-.2-.3-.2-.6s.1-.6.4-.8c.2-.2.6-.3 1-.3s.7.1 1 .3c.2.2.4.7.4.7 0 .1 0 .1-.1.1h-.6c-.1 0-.2-.1-.2-.1s0-.1-.1-.2-.2-.1-.4-.1c-.1 0-.3 0-.3.1-.1.1-.1.2-.1.3 0 .1 0 .2.1.3.1.1.2.1.3.2.1 0 .2.1.4.2s.5.2.6.2c.2.1.3.2.4.3.1.2.2.4.2.6-.3 0-.4.2-.5.3zM130.9 34c0-.1-.1-.1-.2-.1h-1.3c-.1 0-.2.1-.2.1l-.2.5c0 .1-.1.1-.2.1h-.6c-.1 0-.1-.1-.1-.1l1.3-3.6c0-.1.1-.1.2-.1h.6c.1 0 .2.1.2.1l1.3 3.6c0 .1 0 .1-.1.1h-.6c-.1 0-.2-.1-.2-.1l.1-.5zm-.4-.7c.1 0 .1-.1.1-.1l-.5-1.4c0-.1-.1-.1-.1 0l-.5 1.4c0 .1 0 .1.1.1h.9zM135.7 33.9c0 .1.1.1.1.1h1c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1H135c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h.5c.1 0 .1.1.1.1v3.1zM140.6 30.8c.1 0 .1.1.1.1v3.6c0 .1-.1.1-.1.1h-.5c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h.5zM144.4 30.8c.1 0 .2.1.2.1l1 2.8c0 .1.1.1.1 0l1-2.8c0-.1.1-.1.2-.1h.6c.1 0 .1.1.1.1l-1.3 3.6c0 .1-.1.1-.2.1h-.7c-.1 0-.2-.1-.2-.1l-1.3-3.6c0-.1 0-.1.1-.1h.4zM151.3 31.4c-.1 0-.1.1-.1.1v.7c0 .1.1.1.1.1h1.1c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.1c-.1 0-.1.1-.1.1v.8c0 .1.1.1.1.1h1.3c.1 0 .1.1.1.1v.4c0 .1-.1.1-.1.1h-2c-.1 0-.1-.1-.1-.1v-3.6c0-.1.1-.1.1-.1h2c.1 0 .1.1.1.1v.3c0 .1-.1.1-.1.1h-1.3z"/></g></g></svg>
						</router-link>
					</div>
				</div>
				<div class="head-right d-flex flex-wrap align-items-center">
					<ul class="social">
						<!-- <li>
							<a href="https://www.behance.net/luvimac" target="_blank">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.3 7h-6.1V5.5h6.1V7zm-10.2 6.2c.4.6.6 1.4.6 2.2 0 .9-.2 1.7-.7 2.4-.3.5-.6.9-1.1 1.2-.5.4-1.1.6-1.7.8-.7.1-1.4.2-2.1.2H.3V4.9h7.3c1.8 0 3.2.6 3.9 1.6.5.6.7 1.4.7 2.3s-.2 1.7-.7 2.2c-.3.3-.6.6-1.2.9.9.3 1.5.7 1.8 1.3zm-8.3-2.4H7c.7 0 1.2-.1 1.6-.4.4-.2.6-.6.6-1.3s-.3-1.2-.8-1.4c-.5-.1-1.1-.2-1.8-.2H3.8v3.3zm5.7 4.4c0-.8-.3-1.3-1-1.6-.4-.2-.9-.3-1.5-.3H3.8v4H7c.7 0 1.2-.1 1.5-.3.7-.2 1-.8 1-1.8zm15.1-2.4c.1.5.1 1.2.1 2.2h-7.9c0 1.1.4 1.9 1.1 2.3.4.3 1 .4 1.6.4s1.2-.2 1.6-.5c.2-.2.4-.4.6-.7h2.9c-.1.6-.4 1.3-1.1 2-1 1.1-2.3 1.6-4.1 1.6-1.4 0-2.7-.4-3.8-1.3s-1.7-2.3-1.7-4.4c0-1.9.5-3.3 1.5-4.3s2.3-1.5 3.9-1.5c.9 0 1.8.2 2.6.5s1.4.9 1.9 1.6c.4.5.7 1.2.8 2.1zm-2.9.3c-.1-.8-.3-1.3-.8-1.7s-1-.6-1.7-.6-1.3.2-1.7.6c-.4.4-.7 1-.8 1.7h5z"/></svg>
							</a>
						</li> -->
						<li>
							<a href="https://twitter.com/luvimacs" target="_blank">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M24.4 5.1c-.9.4-1.8.6-2.8.8 1-.6 1.8-1.6 2.1-2.7-.9.6-2 1-3.1 1.2-.9-.9-2.1-1.5-3.5-1.5-2.7 0-4.9 2.2-4.9 4.9 0 .4 0 .8.1 1.1-4-.2-7.6-2.1-10-5.1-.5.6-.7 1.4-.7 2.3 0 1.7.9 3.2 2.2 4-.8 0-1.5-.2-2.2-.6v.1c0 2.4 1.7 4.3 3.9 4.8-.4.1-.8.2-1.3.2-.3 0-.6 0-.9-.1.6 1.9 2.4 3.3 4.5 3.4C6.1 19.2 4 20 1.8 20c-.4 0-.8 0-1.2-.1 2.2 1.4 4.7 2.2 7.4 2.2 8.9 0 13.8-7.4 13.8-13.8v-.6c1.1-.8 1.8-1.7 2.6-2.6z"/></svg>
							</a>
						</li>
						<li>
							<a href="https://www.linkedin.com/company/luvimac" target="_blank">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M24.6 24.6v-8.8c0-4.3-.9-7.7-6-7.7-2.4 0-4.1 1.3-4.7 2.6h-.1V8.5H9v16.1h5v-8c0-2.1.4-4.1 3-4.1s2.6 2.4 2.6 4.3v7.8h5zM.8 8.5h5v16.1h-5V8.5zM3.3.4C1.7.4.4 1.7.4 3.3s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9C6.2 1.7 4.9.4 3.3.4z"/></svg>
							</a>
						</li>
						<li>
							<a href="https://www.instagram.com/luvimac/" target="_blank">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.5 6C9 6 6.1 8.9 6.1 12.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4S16 6 12.5 6zm0 10.3c-2.2 0-3.9-1.8-3.9-3.9s1.8-3.9 3.9-3.9 3.9 1.8 3.9 3.9-1.7 3.9-3.9 3.9zM17.7.2H7.3C3.4.2.2 3.4.2 7.3v10.4c0 3.9 3.2 7.1 7.1 7.1h10.4c3.9 0 7.1-3.2 7.1-7.1V7.2c0-3.9-3.2-7-7.1-7zm4.6 17.4c0 2.5-2.1 4.6-4.6 4.6H7.3c-2.5 0-4.6-2.1-4.6-4.6V7.2c0-2.5 2.1-4.6 4.6-4.6h10.4c2.5 0 4.6 2.1 4.6 4.6v10.4zM18.9 4.2c-.9 0-1.6.7-1.6 1.7 0 .9.7 1.7 1.7 1.7.9 0 1.7-.7 1.7-1.7s-.8-1.7-1.8-1.7z"/></svg>
							</a>
						</li>
						<li>
							<a href="https://www.facebook.com/luvimac" target="_blank">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.9 8.4h-3.7V5.9c0-.9.6-1.1 1-1.1h2.6v-4h-3.6c-4 0-4.9 3-4.9 4.9v2.7H7.1v4.1h2.3v11.6h4.8V12.5h3.3l.4-4.1z"/></svg>
							</a>
						</li>
					</ul>

					<div class="btn-dark-light">
						<a href="javascript:void(0)" @click="toggleColor()">
							<Icon name="dark-light-icon" :width="25" :height="25" />
						</a>
					</div>

					<a href="javascript:void(0)" @click="toggleMenu()"
						class="toggle toggleOpen d-flex align-items-center">
						<span class="icon"></span>
					</a>
				</div>
				<div class="head-center" :class="{show:show}">
					<div class="menu-container">
						<a href="javascript:void(0)" @click="toggleMenu()"
							class="toggle toggleClose d-flex align-items-center">
							<span class="icon"></span>
						</a>
						<ul class="menu">
							<li @click="toggleMenu()">
								<router-link to="/">Home</router-link>
							</li>
							<li @click="toggleMenu()">
								<router-link to="/about">About</router-link>
							</li>
							<li @click="toggleMenu()">
								<router-link to="/technology">Technology</router-link>
							</li>
							<li>
								<router-link to=""><span @click="showMenu('services')">Services</span></router-link>
								<div class="menu-arrow" @click="showMenu('services')"
									:class="{ open: activeTab === 'services' }">
									<Icon name="down-arrow-icon" :width="16" :height="16" />
								</div>
								<ul class="sub-menu" :class="{ showMega: activeTab === 'services' }">
									<li @click="toggleMenu()">
										<router-link to="/web-development">Web Development</router-link>
									</li>
									<li>
										<router-link to=""><span @click="showSubMenu('app')">App Development</span></router-link>
										<div class="menu-arrow" @click="showSubMenu('app')" :class="{ open: activeSubTab === 'app' }">
											<Icon name="down-arrow-icon" :width="16" :height="16" />
										</div>
										<ul class="sub-menu" :class="{ showMega: activeSubTab === 'app' }">
											<li @click="toggleMenu()"><router-link to="/android-app-development">Android</router-link></li>
											<li @click="toggleMenu()"><router-link to="/ios-app-development"><span class="text-lowercase">i</span>OS</router-link></li>
											<li @click="toggleMenu()"><router-link to="/flutter-app-development">Flutter</router-link></li>
										</ul>
									</li>
									<li @click="toggleMenu()">
										<router-link to="/digital-marketing">Digital Marketing</router-link>
									</li>
									<li>
										<router-link to=""><span @click="showSubMenu('commerce')">E-commerce</span></router-link>
										<div class="menu-arrow" @click="showSubMenu('commerce')" :class="{ open: activeSubTab === 'commerce' }">
											<Icon name="down-arrow-icon" :width="16" :height="16" />
										</div>
										<ul class="sub-menu" :class="{ showMega: activeSubTab === 'commerce' }">
											<li @click="toggleMenu()"><router-link to="/magento-ecommerce-development">Magento</router-link></li>
											<li @click="toggleMenu()"><router-link to="/wordpress-website-development">Wordpress</router-link></li>
										</ul>
									</li>
								</ul>
							</li>
							<li @click="toggleMenu()">
								<router-link to="/contact-us">Contact Us</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		
	</header>
</template>
<script>
	import Icon from '../inc/Icon.vue';
	export default {
		name: 'Header',
		components: { Icon },
		data() {
			return {
				show: false,
				scrollPosition: null,
				activeTab: '',
				activeSubTab: '',

			}
		},
		mounted() {
			window.addEventListener('scroll', this.updateScroll);
		},
		methods: {
			toggleColor() {
				var app = document.getElementsByTagName("html")[0];
				if (localStorage.lightMode == "dark") {
					localStorage.lightMode = "light";
					app.setAttribute("data-theme", "light");
				} else {
					localStorage.lightMode = "dark";
					app.setAttribute("data-theme", "dark");
				}
			},
			updateScroll() {
				this.scrollPosition = window.scrollY
			},
			toggleMenu() {
				this.show = !this.show
			},
			showMenu(value) {
				if (value == this.activeTab) {
					this.activeTab = ''
				} else {
					this.activeTab = value
				}
			},
			showSubMenu(value) {
				if (value == this.activeSubTab) {
					this.activeSubTab = ''
				} else {
					this.activeSubTab = value
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
.toggle {
	width: 26px;
	height: 20px;
	position: relative;
	span {
		display: block;
		width: 100%;
		height: 2px;
		background: var(--font-stl-two);
		border-radius: 2px;
		&:after,
		&:before {
			content: "";
			position: absolute;
			left: 0;
			right: 0;
			height: 2px;
			background: var(--font-stl-two);
			border-radius: 2px;
		}
		&:after {
			top: 0px;
		}
		&:before {
			bottom: 0px;
		}
	}

	&.toggleOpen {
		margin: 15px 10px;
	}
	&.toggleClose {
		margin: 12px 12px 12px auto;
		span {
			background: none;
			&:after {
				top: auto;
				transform: rotate(45deg);
				background: var(--font-stl-one);
			}
			&:before {
				bottom: auto;
				transform: rotate(-45deg);
				background: var(--font-stl-one);
			}
		}
	}
}

.btn-dark-light {
  a{
    color: #fff;
  }
}

.logo {
	svg {
		height: auto;
		max-width: 150px;
		width: 100%;
		fill: #fff;
	}
}

.header {
	position: absolute;
	left: 0px;
	right: 0;
	top: 0px;
	z-index: 999;
	transition: all 0.3s ease-in-out;
	&.fixed{

	}
}

ul.menu {
	position: relative;

	li {
		position: relative;
	}

	li>a {
		font-size: 12px;
		font-weight: 700;
		text-transform: uppercase;
		display: block;
		padding: 10px 10px;
		letter-spacing: 1px;
	}

	.sub-menu>li>a {
		text-transform: capitalize;
	}
}

.fixed {
	position: fixed;
	background-color: var(--bgw-bgb-color);
	box-shadow: 0 0 transparent, 0 0 transparent, 0 5px 5px -4px rgba(0, 0, 0, 0.10);
	.toggle {
		span {
			background: var(--font-stl-three);
			&:after,
			&:before {
				background: var(--font-stl-three);
			}
		}

		&.toggleClose {
			span {
				background: none;
				&:after,
				&:before {
					background: var(--w-b-color);
				}
			}

		}
	}

	.logo {
		svg {
			fill: var(--font-stl-three);
		}
	}

	.btn-dark-light {
    a{
      color: var(--font-stl-three);
    }
	}

	ul.social {
		li {
			svg {
				fill: var(--font-stl-three);
			}
		}
	}
}

@media(min-width:1025px) {
	.menu-arrow {
		display: none;
	}

	.toggle {
		display: none !important;
	}

	.header {
		.head-left {
			order: 1;
		}

		.head-center {
			margin: 0 auto;
			order: 2;
		}

		.head-right {
			order: 3;
		}
	}

	.menu-container {
		padding: 10px 0px;
	}

	ul.menu {
		display: flex;

		&>li {
			padding: 0px 10px;
		}

		.sub-menu {
			position: absolute;
			top: 100%;
			padding: 10px 0px;
			min-width: 180px;
			background: #ffffff;
			box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.35), 0 -0px 5px 0 rgba(0, 0, 0, 0.35);
			transition: all 0.3s;
			opacity: 0;
			visibility: hidden;
			border-radius: 3px;
			
			

			li {
				padding: 0px 25px;
				display: block;
				a {
					position: relative;
					padding: 0px 0px;
					font-weight: 400;
					overflow: hidden;
					display: inline-block;
					&:after {
						content: " ";
						position: absolute;
						left: 0;
						bottom: 0;
						width: calc(0% - 1px);
						height: 2px;
						background-color: var(--s-color);
						transition: all 0.3s;
					}
					&:hover {
						color: #000000;

						&:after {
							width: calc(100% + 1px);
						}
					}
				}
				&:hover {
					&>a {
						color: #000000;
						&:after {
							width: calc(100% + 1px);
						}
					}
				}
			}
		}

		&>li {
			&>.sub-menu {
				transform: translateY(0px);
				&:after {
					content: "";
					border-left: 10px solid transparent;
					border-right: 10px solid transparent;
					border-bottom: 10px solid #ffffff;
					position: absolute;
					top: -9px;
					left: 30px;
				}
				
				li {
					.sub-menu {
						right: -105%;
						top: 50%;
						transform: translate(20px, -50%);
						&:after {
							content: "";
							border-top: 10px solid transparent;
							border-bottom: 10px solid transparent;
							border-right: 10px solid #ffffff;
							position: absolute;
							top: calc(50% - 10px);
							left: -9px;
						}
					}
				}
			}
		}

		&>li:hover {
			&>.sub-menu {
				transform: translateY(0px);
				opacity: 1;
				visibility: visible;
				
			}
		}

		&>li>.sub-menu li:hover>.sub-menu {
			transform: translate(0px, -50%);
			opacity: 1;
			visibility: visible;
		}
	}

	ul.menu {
		&>li>a {
			color: #fff;
		}

		.sub-menu {
			li {
				a {
					color: #000000;
				}
			}
		}
	}

	.fixed {
		ul.menu {
			&>li>a {
				color: var(--font-stl-three);
			}
		}
	}

	.side-menu-overlay {
		display: none;
	}

}

@media(max-width:1024px) {
	.menu-arrow {
    color: var(--font-stl-one);
		transition: all 0.3s ease-in-out;
		cursor: pointer;
		padding: 8px 10px;
		margin-left: auto;
		&.open {
			transform: rotate(180deg);
		}
	}

	ul.menu {
		&>li>a {
			color: var(--font-stl-one);
		}

		ul.sub-menu {
			transition: all 0.3s ease-in-out;
			display: none;

			&>li {
				padding-left: 10px;

				a {
					color: var(--font-stl-one);
				}
			}

			&.showMega {
				display: block;
			}
		}

	}

	ul.menu {
		li {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
		}

		ul.sub-menu {
			width: 100%;
		}
	}

	.header {
		.head-right {
			margin-left: auto;
		}

		.head-center {
			position: fixed;
			right: 0;
			top: 0;
			bottom: 0;
			width: 250px;
			background: red;
			background: var(--bgw-bgb-color);
			transform: translateX(100%);
			transition: all 0.3s;
			z-index: 2;

			&.show {
				transform: translateX(0%);
			}

			.menu-container {
				height: 100vh;
				overflow: auto;
			}

		}
	}


	.side-menu-overlay {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: #000;
		transition: 0.3s ease-in-out;
		opacity: 0.5;
		z-index: 1;
	}

	.side-menu-overlay:not(.sideOverlay) {
		visibility: hidden;
		opacity: 0;
	}

}

@media(max-width:767px) {
	.logo {
		svg {
			max-width: 120px;
		}
	}

	.toggle {
		&.toggleOpen {
			margin-right: 0;
		}
	}
}

</style>